/**
 * Perceived brightness of a SKU's colour, so a white or yellow band keeps dark text instead of
 * white on white. A colour that cannot be read is treated as light, which keeps the text dark.
 */
export function isLight(hex: string | null | undefined): boolean {
  const m = /^#?([0-9a-f]{6})$/i.exec((hex ?? '').trim());
  if (!m) return true;
  const n = Number.parseInt(m[1]!, 16);
  return (0.299 * ((n >> 16) & 255) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255 > 0.62;
}
